import { useAuth } from '../../hooks/useAuth';
import { MainLayout } from '../../components/MainLayout';

export function ProfilePage() {
  const { user, logout } = useAuth();

  return (
    <MainLayout>
      <div class="flex-1 overflow-auto">
        <div class="container mx-auto p-8 max-w-2xl">
        <h1 class="text-3xl font-bold mb-8">Profile</h1>

        <div class="card bg-base-200">
          <div class="card-body">
            <h2 class="card-title">User Information</h2>

            <div class="space-y-4">
              <div>
                <label class="text-sm opacity-70">Name</label>
                <p class="text-lg">{user?.name || 'Not set'}</p>
              </div>

              <div>
                <label class="text-sm opacity-70">Email</label>
                <p class="text-lg">{user?.email || 'Not set'}</p>
              </div>
            </div>

            <div class="divider"></div>

            <div class="card-actions">
              <button class="btn btn-error" onClick={logout}>
                Logout
              </button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </MainLayout>
  );
}
